import { BsPlusCircle } from "react-icons/bs";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import { useDisclosure } from "@chakra-ui/hooks";
import { Select as AntSelect } from "antd";
import Checkbox from "components/checkbox";
import { MultiSelect } from "react-multi-select-component";
import { useEffect, useState } from "react";
import { getClientDetails } from "api/graphQL_dashboard";
import toast from "react-hot-toast";
import { currencyCodes, getCurrencySymbol } from "utils/currencyList";
import {
  scheduleSettlement,
  updateScheduleSettlement,
  getClientPaymentMethodDetailsSettlement,
  updateSettlementRecord,
  getScheduleSettlement,
} from "api/settlement";
import { getUserId } from "utils/auth";
import { MdEdit, MdHighlightOff } from "react-icons/md";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DivLoader from "components/divloader/DivLoader";
import _ from "lodash";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";
import { Portal } from "@chakra-ui/portal";
import moment from "moment";

const STATIC_PAYMENT_OPTIONS = ["APM"];

function ScheduleSettlement(props: {
        allOrgDetails: any;
        fetchAllsettlement: () => void;
        id?: any;
    }) {

    const { allOrgDetails,fetchAllsettlement,id} = props;
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectOrg, setSelectOrg] = useState<any>();
    const [selectCurrency, setSelectCurrency] = useState<any>("USDT");
    const [allClientDetails, setAllClientDetails] = useState<any>([]);
    const [initialValues, setInitialFormValues] = useState<any>([]);
    const [selectClients, setSelectClients] = useState<any>([]);
    const [selectStatus, setSelectStatus] = useState<any>([]);
    const [clientPaymentMethod, setClientPaymentMethod] = useState<any>([]);
    const [clientCardType, setClientCardType] = useState<any>([]);
    const [isCloseModal, setIsCloseModal] = useState<boolean>(false);
    const [selectPaymentMethod, setSelectPaymentMethod] = useState<any>([]);
    const [formValuesErr, setFormValuesErr] = useState<any>([]);
    const [isLoadingGenerate, setIsLoadingGenerate] = useState(false);
    const [isLoadingDetails, setIsLoadingDetails] = useState(false);
    const [scheduleData, setScheduleData] = useState({
        schedule_type: "",
        execution_time: "",
        execution_day: "",
    });
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [popoverOpenE, setPopoverOpenE] = useState(false);
    const [savedPaymentMethods, setSavedPaymentMethods] = useState<any[]>([]);

    const hasValidSchedule =
        scheduleData.schedule_type &&
        scheduleData.execution_time &&
        (
            scheduleData.schedule_type === "daily" ||
            scheduleData.schedule_type === "monthly" ||
            scheduleData.execution_day
        );

    const allPaymentOptions = [
        ...clientCardType,
        ...STATIC_PAYMENT_OPTIONS.filter(
        (opt) => !clientCardType.includes(opt)
        ),
    ];

    const handleClose = () => {
        setSelectClients([]);
        setSelectOrg("");
        setSelectCurrency("USDT");
        setAllClientDetails([]);
        setSelectClients([]);
        setSelectStatus([]);
        setClientPaymentMethod([]);
        setClientCardType([]);
        setSelectPaymentMethod([]);
        setFormValuesErr([]);
        setIsCloseModal(true);
        setPopoverOpenE(false)
        setPopoverOpen(false)
        setTimeout(() => {
            setIsCloseModal(false);
            onClose();
        }, 320);
    };

    const checkFilterData = () => !!(selectOrg && selectClients?.length > 0 && selectCurrency);

    const fetchSettlement = () => {
        setIsLoadingDetails(true)
        getScheduleSettlement(id)
        .then((data) => {
            setSelectOrg(data?.settlement_details?.organization_id)
            setSelectClients(data?.settlement_details?.client_ids)
            setSavedPaymentMethods(data?.settlement_details?.payment_methods || []);
            setSelectStatus([])
            setSelectCurrency(data?.settlement_details?.settlement_currency)
            setScheduleData(
                {
                    schedule_type: data?.schedule_type,
                    execution_time: data?.execution_time,
                    execution_day: data?.execution_day ?? "",
                }
            )
            setIsLoadingDetails(false)
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message ?? "Settlement paused failed");
        });
    }

    const fetchClientData = () => {
        getClientDetails({ org_ids: selectOrg })
        .then((res) => {
            setAllClientDetails(
              res?.length > 0
                ? res.map((d: any) => ({ ...d, label: d?.name, value: d?.id }))
                : []
            );
        })
        .catch(() => {
            toast.error("Something went wrong!");
            setAllClientDetails([]);
        });
    };

    const fetchPaymentMethodData = (preserveSelection = false) => {
        getClientPaymentMethodDetailsSettlement({ client_ids: selectClients?.toString() })
        .then((res) => {
            setClientPaymentMethod(res?.payment_methods || []);
            setClientCardType(res?.card_types || []);
            if (savedPaymentMethods.length > 0) {
                setSelectPaymentMethod(
                    savedPaymentMethods.map((pm: any) => ({
                        name: pm.name,
                        isSelected: true,
                    }))
                );
            }
            if (!preserveSelection) {
                setSelectPaymentMethod([]);
            }
        })
        .catch(() => {
            toast.error("Something went wrong!");
            setClientPaymentMethod([]);
        });
    };

    const hasSelectedPaymentMethod = selectPaymentMethod?.some(
        (item: any) => item.isSelected
    );
    
    const validateForm = () => {
        const hasSelectedPaymentMethod = selectPaymentMethod?.some(
            (method: any) => method.isSelected
        );

        const errors: any = {};

        if (!hasSelectedPaymentMethod) {
            errors.payment_methods = "Please select at least one payment method.";
        }

        if (!scheduleData.schedule_type) {
            errors.schedule_type = "Please select schedule type.";
        }

        if (!scheduleData.execution_time) {
            errors.execution_time = "Please select execution time.";
        }

        if ((scheduleData.schedule_type === "weekly" || scheduleData.schedule_type === "biweekly") && !scheduleData.execution_day) {
            errors.execution_day = "Please select execution day.";
        }

        setFormValuesErr(errors);

        return Object.keys(errors).length === 0;
    };

    const handleSubmit = () => {
        if (!validateForm()) return;

        const data = {
            organization_id: selectOrg,
            client_ids: selectClients.filter((f: any) => f !== "All"),
            payment_methods: selectPaymentMethod
                ?.filter((f: any) => f.isSelected)
                ?.map((data: any) => ({
                    name: data.name,
                })),
            status: selectStatus.filter((f: any) => f !== "All"),
            settlement_currency: selectCurrency,
            created_by: getUserId(),
        };

        const final_data = {
            settlement_object: data,
            schedule_type: scheduleData.schedule_type,
            schedule_details: {
                execution_time: scheduleData.execution_time,
                execution_day: scheduleData.execution_day,
            },
        };

        setIsLoadingGenerate(true);

        if(id) {
            updateScheduleSettlement(final_data,id)
            .then(() => {
                toast.success("Scheduled settlement updated successfully.");
                fetchAllsettlement();
                handleClose();
            })
            .catch((error) => {
                const errorMessage = error.response.data.message;
                toast.error(errorMessage || "Something went wrong!");
            })
            .finally(() => { setIsLoadingGenerate(false); });
        } else {

            scheduleSettlement(final_data)
            .then(() => {
                toast.success("Scheduled settlement successfully.");
                fetchAllsettlement();
                handleClose();
            })
            .catch((error) => {
                const errorMessage = error.response.data.message;
                toast.error(errorMessage || "Something went wrong!");
            })
            .finally(() => { setIsLoadingGenerate(false); });

        }

    };

    useEffect(() => { if (selectOrg) fetchClientData(); }, [selectOrg]);

    useEffect(() => {
        if (selectClients?.length > 0) {
            fetchPaymentMethodData(!!id);
        }
    }, [selectClients]);

    const togglePaymentMethod = (method: string) => {
        setSelectPaymentMethod((prev: any) => {
            const existing = prev?.find((f: any) => f.name === method);
            const updated = existing
                ? prev.map((item: any) => item.name === method ? { ...item, isSelected: !item.isSelected } : item)
                : [...(prev || []), { name: method, isSelected: true }];

            if (formValuesErr?.payment_methods) {
                const hasSelected = updated.some((m: any) => m.isSelected);
                setFormValuesErr({payment_methods: hasSelected ? "" : "Please select at least one payment method.",});
            }

            return updated;
        });
    };

    const TriggerEl = () => {
        return id ? (
            <Popover trigger="hover" placement="bottom" closeOnBlur  closeOnEsc isOpen={popoverOpenE && !isOpen} onOpen={() => setPopoverOpenE(true)} onClose={() => setPopoverOpenE(false)}>
                <PopoverTrigger>
                <div onClick={() => { if (id) fetchSettlement();  onOpen(); }} onMouseEnter={() => !isOpen && setPopoverOpenE(true)} onMouseLeave={() => setPopoverOpenE(false)}>
                    <div className="ccm-action-icon ccm-action-icon--amber"><MdEdit size={14} /></div>
                </div>
                </PopoverTrigger>
                <PopoverContent border="1px solid #fde68a" borderRadius="12px" bg="#fffbeb" maxW="200px" p="0" overflow="hidden" zIndex="20">
                <PopoverHeader bg="#fef3c7" fontSize="12px" fontWeight="700" color="#92400e" borderBottom="1px solid #fde68a" px="12px" py="9px">Edit Settlement</PopoverHeader>
                <PopoverArrow bg="#fffbeb" />
                </PopoverContent>
            </Popover>
        ) : (
            <button className="smt-add-btn" onClick={() => onOpen()}>
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                </svg>
                Schedule Settlement
            </button>
        );
    };

    return (
        <>
            <TriggerEl />
            <Modal isOpen={isOpen} onClose={() => {}}>
                <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />
                <div className={`smt-panel${isOpen && !isCloseModal ? " smt-panel--open" : " smt-panel--close"}`}>
                    <div className="smt-top-glow" />

                    <div className="smt-header">
                        <div className="smt-header-brand">
                            <div className="smt-header-logo">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="1" y="4" width="22" height="16" rx="2" />
                                <line x1="1" y1="10" x2="23" y2="10" />
                            </svg>
                            </div>
                            <div>
                            <h2 className="smt-header-title">
                                {id ?  "Update Scheduled Settlement":"Schedule Settlement"}
                            </h2>
                            <p className="smt-header-sub">
                                {id ?  "Update Scheduled settlement":"Schedule a new settlement"}
                                
                            </p>
                            </div>
                        </div>
                        <button className="smt-close-btn" onClick={handleClose} aria-label="Close">
                            <MdHighlightOff size={22} />
                        </button>
                    </div>

                    <div className="smt-content-area">
                        <div className="smt-section">
                            {id && isLoadingDetails ? (
                                <div className="st-loading">
                                    <div className="st-spinner" />
                                    <p className="st-loading-txt">Loading scheduled settlements details</p>
                                </div>
                            ) : (
                                <>
                                    {/* settlement details section */}
                                    <div className="smt-section-card">
                                        <div className="smt-card-header">
                                            <div>
                                                <h3 className="smt-card-title">Settlement Details</h3>
                                                <p className="smt-card-subtitle">
                                                    Configure settlement information
                                                </p>
                                            </div>
                                        </div>
                                        <div className="smt-form-row mb-2">
                                            <div className="smt-field-wrap  mt-2">
                                                <label className="smt-label">Organization <span className="smt-req">*</span></label>
                                                <AntSelect
                                                allowClear
                                                showSearch
                                                placeholder="Select organization"
                                                optionFilterProp="label"
                                                filterOption
                                                className="smt-ant-select"
                                                style={{ width: "100%" }}
                                                options={allOrgDetails}
                                                value={selectOrg || undefined}
                                                onChange={(event) => {
                                                    setSelectOrg(event);
                                                    setSelectClients([]);
                                                }}
                                                notFoundContent="No options found"
                                                />
                                            </div>
                                            <div className="smt-field-wrap  mt-2">
                                                <label className="smt-label">Client(s) <span className="smt-req">*</span></label>
                                                <div className={`smt-multiselect-wrap${!selectOrg ? " smt-multiselect-wrap--disabled" : ""}`}>
                                                    <MultiSelect
                                                        options={allClientDetails}
                                                        value={allClientDetails.filter((opt: any) => (selectClients || []).includes(opt.value))}
                                                        onChange={(selectedOptions: any) => {
                                                        setSelectPaymentMethod([]);
                                                        setSelectClients(selectedOptions.map((opt: any) => opt.value));
                                                        }}
                                                        labelledBy="Select client(s)"
                                                        disabled={!selectOrg}
                                                        className="smt-multiselect"
                                                        overrideStrings={{ noOptions: "No clients found!" }}
                                                        valueRenderer={(selected, options) => {
                                                        if (selected.length === 0) return "Select client(s)";
                                                        if (selected.length === options.length) return "All clients selected";
                                                        return selected.map((o) => o.label).join(", ");
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {selectClients?.length > 0 && (
                                            <div className="smt-field-wrap">
                                                <label className="smt-label">Payment Methods <span className="smt-req">*</span></label>
                                                <div className="smt-pm-grid">
                                                {allPaymentOptions.length > 0 ? (
                                                    allPaymentOptions.map((method: any, index: any) => {
                                                    const isStatic = STATIC_PAYMENT_OPTIONS.includes(method);
                                                    const isSelected = selectPaymentMethod?.find((f: any) => f.name === method)?.isSelected ?? false;
                                                    return (
                                                        <div key={index} className={`smt-pm-item ${isSelected ? "smt-pm-item--active" : ""}`} onClick={() => togglePaymentMethod(method)}>
                                                            <div className="smt-pm-left">
                                                                <div  className="smt-pm-check-label">
                                                                <Checkbox
                                                                    id={method}
                                                                    value={!isSelected}
                                                                    className="h-4 w-4"
                                                                    color=""
                                                                    checked={isSelected}
                                                                    onClick={(e: any) => e.stopPropagation()}
                                                                    onChange={() => togglePaymentMethod(method)}
                                                                />
                                                                <span className="smt-pm-name">
                                                                    {method}
                                                                    {isStatic && (
                                                                        <span className="smt-pm-badge">APM</span>
                                                                    )}
                                                                </span>
                                                                </div >
                                                            </div>
                                                        </div>
                                                    );
                                                    })
                                                ) : (
                                                    <p className="smt-pm-empty">No payment methods available</p>
                                                )}
                                                </div>
                                                {formValuesErr?.payment_methods && (
                                                    <div className="smt-field-err">
                                                        {formValuesErr.payment_methods}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="smt-field-wrap mt-2 mb-3">
                                            <label className="smt-label">Settlement Currency <span className="smt-req">*</span></label>
                                            <AntSelect
                                                showSearch
                                                allowClear
                                                placeholder="Select currency"
                                                optionFilterProp="children"
                                                filterOption={(input, option) => (option?.label ?? "").includes(input?.toUpperCase())}
                                                filterSort={(a, b) => (a?.label ?? "").toLowerCase().localeCompare((b?.label ?? "").toLowerCase())}
                                                className="smt-ant-select"
                                                style={{ width: "100%" }}
                                                options={currencyCodes.map((currencyCode) => {
                                                const currencyDetails = getCurrencySymbol(currencyCode);
                                                return { value: currencyCode, label: `${currencyCode}: ${currencyDetails.title?.toUpperCase()}` };
                                                })}
                                                value={selectCurrency || undefined}
                                                onChange={(e) => setSelectCurrency(e)}
                                                notFoundContent="No options found"
                                            />
                                        </div>
                                    </div>
                                    {/* schedule details section */}
                                    <div className="smt-section-card">
                                        <div className="smt-card-header">
                                            <div>
                                                <h3 className="smt-card-title">
                                                    Schedule Details
                                                </h3>
                                                <p className="smt-card-subtitle">
                                                    Configure recurring settlement schedule
                                                </p>
                                            </div>
                                        </div>
                                        <div className="smt-form-row">
                                            <div className="smt-field-wrap mt-2">
                                                <label className="smt-label">
                                                    Schedule Type
                                                    <span className="smt-req">*</span>
                                                </label>
                                                <AntSelect
                                                    className="smt-ant-select"
                                                    placeholder="Select schedule"
                                                    style={{ width: "100%" }}
                                                    options={[{value: "daily",label: "Daily"},{value: "weekly",label: "Weekly"},{value: "monthly",label: "Monthly"}]}
                                                    value={scheduleData.schedule_type || undefined}
                                                    onChange={(value) =>
                                                        setScheduleData((prev) => ({
                                                            ...prev,
                                                            schedule_type: value,
                                                            execution_day: "",
                                                        }))
                                                    }
                                                />
                                            </div>
                                            <div className="smt-field-wrap mt-2">
                                                <label className="smt-label">
                                                    Execution Time <span className="smt-req">*</span>
                                                </label>
                                                <input
                                                    type="time"
                                                    className="smt-time-input"
                                                    value={scheduleData.execution_time}
                                                    onChange={(e) =>
                                                        setScheduleData((prev) => ({
                                                            ...prev,
                                                            execution_time: e.target.value,
                                                        }))
                                                    }
                                                />
                                            </div>
                                        </div>
                                        {(scheduleData.schedule_type === "weekly" || scheduleData.schedule_type === "biweekly") && (
                                            <div className="smt-field-wrap mt-2">
                                                <label className="smt-label"> Execution Day </label>
                                                <div className="smt-radio-grid">
                                                    {["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map(day => (
                                                        <label key={day} className="smt-radio-item">
                                                            <input
                                                                type="radio"
                                                                name="execution_day"
                                                                checked={scheduleData.execution_day === day}
                                                                onChange={() =>
                                                                    setScheduleData((prev) => ({
                                                                        ...prev,
                                                                        execution_day: day,
                                                                    }))
                                                                }
                                                            />
                                                            <span>{day}</span>
                                                        </label>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                        {scheduleData.schedule_type === "monthly" && (
                                            <div className="smt-info-box mt-3">
                                                <svg width="18" height="18" viewBox="0 0 24 24"  fill="none" stroke="currentColor" strokeWidth="2">
                                                    <circle cx="12" cy="12" r="10" />
                                                    <line x1="12" y1="16"  x2="12" y2="12" />
                                                    <line x1="12" y1="8" x2="12.01"  y2="8" />
                                                </svg>
                                                <div >
                                                    <strong >Monthly Schedule</strong>
                                                    <p> Settlement reports will automatically be generated on the last day of every month at the selected execution time.</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    
                    <div className="smt-footer">
                        <div className="smt-footer-hint">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                        </svg>
                        Encrypted &amp; secure
                        </div>
                        <div className="smt-footer-btns">
                            <button className="smt-btn-cancel" onClick={handleClose} disabled={isLoadingGenerate}>
                                Cancel
                            </button>
                            <button
                                className="smt-btn-submit"
                                onClick={handleSubmit}
                                disabled={
                                    !checkFilterData() ||
                                    isLoadingGenerate ||
                                    allPaymentOptions.length === 0 ||
                                    selectClients.length === 0 ||
                                    !selectOrg ||
                                    !hasSelectedPaymentMethod ||
                                    !hasValidSchedule
                                }
                            >
                                {isLoadingGenerate ? (
                                <span className="smt-spinner" />
                                ) : id ? (
                                    <>
                                        <MdEdit size={14} /> Update Now
                                    </>
                                ) : (
                                    <>
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                        <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        Schedule Now
                                    </>
                                    
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
                /* ── Trigger icons ── */
                .ccm-action-icon { width:28px;height:28px;border-radius:8px;display:flex;align-items:center;justify-content:center;cursor:pointer;transition:all .15s;border:1.5px solid; }
                .ccm-action-icon--blue  { background:#eff6ff;border-color:#bfdbfe;color:#2563eb; }
                .ccm-action-icon--blue:hover  { background:#dbeafe;border-color:#93c5fd; }
                .ccm-action-icon--amber { background:#fffbeb;border-color:#fde68a;color:#d97706; }
                .ccm-action-icon--amber:hover { background:#fef3c7;border-color:#fcd34d; }
                .smt-add-btn {
                display: inline-flex; align-items: center; gap: 7px;
                font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
                padding: 9px 18px; border-radius: 10px; border: none;
                background: linear-gradient(135deg, #1d4ed8, #2563eb);
                cursor: pointer; box-shadow: 0 3px 12px rgba(37,99,235,.3);
                transition: transform .15s, box-shadow .18s;
                }
                .smt-add-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 20px rgba(37,99,235,.38); }

                /* Action icons */
                .smt-action-icon {
                width: 32px; height: 32px; border-radius: 8px;
                display: flex; align-items: center; justify-content: center;
                cursor: pointer; transition: all .15s; border: 1.5px solid;
                }
                .smt-action-icon--amber { background: #fffbeb; border-color: #fde68a; color: #d97706; }
                .smt-action-icon--amber:hover { background: #fef3c7; border-color: #fcd34d; }

                /* Slide panel */
                .smt-panel {
                font-family: 'Plus Jakarta Sans', sans-serif;
                position: fixed; top: 0; right: 0; bottom: 0;
                width: 100%; max-width: 640px;
                background: #ffffff;
                z-index: 1004;
                display: flex; flex-direction: column;
                box-shadow: -12px 0 60px rgba(15,23,42,.18);
                transition: transform .35s cubic-bezier(0.16,1,0.3,1);
                overflow: hidden;
                }
                .smt-panel--open { transform: translateX(0); }
                .smt-panel--close { transform: translateX(100%); }

                /* Top glow */
                .smt-top-glow {
                height: 3px;
                background: linear-gradient(90deg,#0f2744,#2563eb,#7c3aed,#2563eb,#0f2744);
                background-size: 200% 100%;
                animation: smtGlow 3s linear infinite; flex-shrink: 0;
                }
                @keyframes smtGlow { 0%{background-position:0%} 100%{background-position:200%} }

                /* Header */
                .smt-header {
                padding: 15px 26px;
                background: linear-gradient(135deg,#0f2744 0%,#1a3d6b 60%,#1d4ed8 100%);
                display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
                }
                .smt-header-brand { display: flex; align-items: center; gap: 13px; }
                .smt-header-logo {
                width: 42px; height: 42px; border-radius: 12px;
                background: rgba(255,255,255,.15); border: 1.5px solid rgba(255,255,255,.25);
                display: flex; align-items: center; justify-content: center; flex-shrink: 0;
                }
                .smt-header-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 1; }
                .smt-header-sub { font-size: 12px; color: rgba(255,255,255,.55); font-weight: 500; }
                .smt-close-btn {
                background: none; border: none; cursor: pointer;
                color: rgba(255,255,255,.65); display: flex; align-items: center; padding: 2px; transition: color .15s;
                }
                .smt-close-btn:hover { color: #fff; }

                /* Content */
                .smt-content-area { flex: 1; overflow-y: auto; overflow-x: hidden; }
                .smt-content-area::-webkit-scrollbar { width: 4px; }
                .smt-content-area::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
                .smt-section { padding: 24px 28px; display: flex; flex-direction: column; gap: 20px; }

                /* Fields */
                .smt-field-wrap { display: flex; flex-direction: column; gap: 7px; }
                .smt-label { font-size: 12.5px; font-weight: 700; color: #374151; display: block; }
                .smt-req { color: #dc2626; }

                /* Ant Select override */
                .smt-ant-select .ant-select-selector { 
                    height: 46px !important;
                    min-height: 46px !important;
                    display: flex !important;
                    align-items: center !important;
                }
                .smt-ant-select .ant-select-selection-item,
                .smt-ant-select .ant-select-selection-placeholder {
                    line-height: 44px !important;
                }
                .smt-ant-select .ant-select-selection-item { line-height: 44px !important; }

                /* Multiselect */
                .smt-multiselect-wrap .dropdown-container {
                    min-height: 46px !important;
                    height: 46px !important;
                    display: flex;
                    align-items: center;
                    padding: 0 12px;
                }

                .smt-multiselect-wrap .dropdown-heading {
                    min-height: 44px !important;
                    height: 44px !important;
                    display: flex;
                    align-items: center;
                }

                .smt-multiselect-wrap .dropdown-heading-value {
                    display: flex;
                    align-items: center;
                }
                .smt-multiselect-wrap .dropdown-container:focus-within { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37,99,235,.1) !important; }
                .smt-multiselect-wrap--disabled { opacity: .65; pointer-events: none; }
                .dropdown-content { z-index: 9999 !important; }

                /* Payment method rows */
                .smt-pm-card {
                background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 12px;
                padding: 8px; display: flex; flex-direction: column; gap: 4px;
                }
                .smt-pm-row {
                display: grid; grid-template-columns: 160px 1fr;
                align-items: center; gap: 12px;
                padding: 10px 12px; border-radius: 9px; background: #fff;
                border: 1px solid #f1f5f9; transition: border-color .15s;
                }
                .smt-form-row {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    gap: 18px;
                }

                .smt-pm-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
                    gap: 12px;

                    padding: 14px;
                    border: 1.5px solid #e2e8f0;
                    border-radius: 12px;
                    background: #f8fafc;
                }

                .smt-pm-item {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    padding: 10px 12px;
                    border-radius: 10px;
                    background: #fff;
                    border: 1px solid #edf2f7;
                    cursor: pointer;
                    transition: all .2s ease;
                }

                .smt-pm-item:hover {
                    border-color: #2563eb;
                    background: #f9fbff;
                }
                .smt-pm-item--active {
                    border-color: #2563eb;
                    background: #dbeafe;
                    box-shadow: inset 0 0 0 1px #2563eb;
                }
                .smt-pm-row:hover { border-color: #e2e8f0; }

                /* Static APM row gets a subtle teal tint to distinguish it */
                .smt-pm-row--static {
                background: #f0fdfa;
                border-color: #99f6e4;
                }
                .smt-pm-row--static:hover { border-color: #5eead4; }

                .smt-pm-left { display: flex; align-items: center; }
                .smt-pm-check-label { display: flex; align-items: center; gap: 8px; cursor: pointer; }
                .smt-pm-name { font-size: 13px; font-weight: 600; color: #374151; display: flex; align-items: center; gap: 6px; }
                .smt-pm-right { display: flex; flex-direction: column; gap: 4px; }
                .smt-pm-empty { font-size: 13px; color: #94a3b8; text-align: center; padding: 16px; font-weight: 500; }

                /* APM badge */
                .smt-pm-badge {
                display: inline-flex; align-items: center;
                font-size: 10px; font-weight: 700; letter-spacing: 0.4px;
                padding: 2px 7px; border-radius: 5px;
                background: linear-gradient(135deg, #ccfbf1, #99f6e4);
                border: 1px solid #5eead4;
                color: #0f766e;
                text-transform: uppercase;
                }

                /* Datepicker */
                .smt-datepicker {
                width: 100%; padding: 10px 12px; border: 1.5px solid #e2e8f0 !important;
                border-radius: 9px; background: #f8fafc;
                font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; color: #0f172a;
                outline: none; transition: border-color .18s;
                }
                .smt-datepicker:focus { border-color: #2563eb !important; background: #fff; box-shadow: 0 0 0 3px rgba(37,99,235,.1); }
                .smt-datepicker--err { border-color: #ef4444 !important; background: #fff7f7 !important; }
                .smt-datepicker:disabled { background: #f1f5f9; color: #94a3b8; cursor: not-allowed; }
                .smt-field-err { font-size: 12px; color: #dc2626; font-weight: 500; }

                /* Footer */
                .smt-footer {
                padding: 14px 26px;
                border-top: 1.5px solid #f1f5f9;
                background: #fafbfc;
                display: flex; align-items: center; justify-content: space-between;
                flex-wrap: wrap; gap: 10px; flex-shrink: 0;
                }
                .smt-footer-hint { display: flex; align-items: center; gap: 5px; font-size: 12px; color: #94a3b8; font-weight: 500; }
                .smt-footer-btns { display: flex; align-items: center; gap: 8px; }

                .smt-btn-cancel {
                font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; color: #64748b;
                padding: 9px 16px; border-radius: 10px; border: 1.5px solid #e2e8f0; background: #fff;
                cursor: pointer; transition: all .15s;
                }
                .smt-btn-cancel:hover { background: #f1f5f9; color: #374151; }
                .smt-btn-cancel:disabled { opacity: .5; cursor: not-allowed; }

                .smt-btn-submit {
                display: inline-flex; align-items: center; gap: 7px;
                font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
                padding: 10px 20px; border-radius: 10px; border: none;
                background: linear-gradient(135deg, #15803d, #16a34a);
                cursor: pointer; box-shadow: 0 4px 14px rgba(22,163,74,.3);
                transition: transform .15s, box-shadow .18s, opacity .18s;
                }
                .smt-btn-submit:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(22,163,74,.4); }
                .smt-btn-submit:disabled { opacity: .5; cursor: not-allowed; transform: none; box-shadow: none; }

                .smt-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,.35); border-top-color: #fff; border-radius: 50%; animation: smtSpin .65s linear infinite; }
                @keyframes smtSpin { to{transform:rotate(360deg)} }

                .smt-section-card{
                    background: #ffffff;
                    border: 1px solid #dbe4f0;
                    border-radius: 14px;
                    padding: 18px 20px 20px;
                    box-shadow:
                        0 1px 2px rgba(15,23,42,.04),
                        0 6px 18px rgba(15,23,42,.05);
                    transition: all .2s ease;
                }

                .smt-section-card:hover{
                    box-shadow:
                        0 4px 10px rgba(15,23,42,.05),
                        0 10px 24px rgba(15,23,42,.07);
                }

                .smt-card-header{
                    margin: -18px -20px 18px;
                    padding: 14px 20px;
                    background: #f8fafc;
                    border-bottom: 1px solid #e8edf5;
                    border-radius: 14px 14px 0 0;
                }

                .smt-card-title{
                    margin:0;
                    font-size:15px;
                    font-weight:700;
                    color:#0f172a;
                    line-height:22px !important;
                }

                .smt-card-subtitle{
                    margin-top:3px;
                    font-size:12px;
                    color:#64748b;
                    font-weight:500;
                }

                .smt-time-input{
                    height:46px;
                    width:100%;
                    border:1.5px solid #e2e8f0;
                    border-radius:11px;
                    padding:0 14px;
                    background:#f8fafc;
                }

                .smt-radio-grid{
                    display:grid;
                    grid-template-columns:repeat(4,1fr);
                    gap:10px;
                }

                .smt-radio-item{
                    display:flex;
                    align-items:center;
                    gap:8px;
                    padding:10px 12px;
                    border:1px solid #e2e8f0;
                    border-radius:10px;
                    cursor:pointer;
                    transition:.2s;
                }

                .smt-radio-item:hover{
                    border-color:#2563eb;
                    background:#eff6ff;
                }

                .smt-info-box{
                    display:flex;
                    gap:14px;
                    padding:14px 16px;
                    border-radius:10px;
                    background:#eff6ff;
                    border:1px solid #bfdbfe;
                    color:#1e3a8a;
                }

                .smt-info-box p{
                    margin-top:4px;
                    font-size:12px;
                    line-height:1.5;
                    color:#475569;
                }

                .smt-ant-select .ant-select-arrow {
                    top: 95% !important;
                    transform: translateY(-50%) !important;
                }

                @media (max-width: 640px) {

                    /* Panel */
                    .smt-panel {
                        width: 100%;
                        max-width: 100%;
                    }

                    /* Header */
                    .smt-header {
                        padding: 16px 18px;
                    }

                    /* Main content */
                    .smt-section {
                        width: 100%;
                        padding: 18px 16px;
                        box-sizing: border-box;
                    }

                    /* Cards */
                    .smt-section-card {
                        width: 100%;
                        max-width: 100%;
                        box-sizing: border-box;
                        padding: 16px;
                    }

                    .smt-card-header {
                        margin: -16px -16px 16px;
                        padding: 13px 16px;
                    }

                    /* Organization + Client:
                    stack vertically on mobile */
                    .smt-form-row {
                        grid-template-columns: minmax(0, 1fr) !important;
                        gap: 14px;
                    }

                    .smt-field-wrap {
                        width: 100%;
                        min-width: 0;
                    }

                    /* Client dropdown */
                    .smt-multiselect-wrap {
                        width: 100%;
                        max-width: 100%;
                        min-width: 0;
                        box-sizing: border-box;
                    }

                    .smt-multiselect-wrap .dropdown-container {
                        width: 100% !important;
                        max-width: 100%;
                        min-width: 0;
                        box-sizing: border-box;
                    }

                    .smt-multiselect-wrap .dropdown-heading {
                        width: 100%;
                        max-width: 100%;
                        min-width: 0;
                        box-sizing: border-box;
                        overflow: hidden;
                    }

                    .smt-multiselect-wrap .dropdown-heading-value {
                        min-width: 0;
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    /* Payment methods */
                    .smt-pm-grid {
                        grid-template-columns: 1fr;
                    }

                    /* Execution days */
                    .smt-radio-grid {
                        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
                        gap: 8px;
                        width: 100%;
                    }

                    .smt-radio-item {
                        width: 100%;
                        min-width: 0;
                        box-sizing: border-box;
                        padding: 10px 8px;
                    }

                    .smt-radio-item span {
                        min-width: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    /* Footer */
                    .smt-footer {
                        padding: 12px 18px;
                        flex-direction: column;
                        align-items: stretch;
                    }

                    .smt-footer-hint {
                        justify-content: center;
                    }

                    .smt-footer-btns {
                        width: 100%;
                        display: flex;
                    }

                    .smt-btn-cancel,
                    .smt-btn-submit {
                        flex: 1;
                        justify-content: center;
                    }
                }
            `}</style>
        </>
    )

}

export default ScheduleSettlement;